import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { DigiUserFilters } from "../../types/admin/digiUserFilters";

// ---------- COMPONENT ----------
interface Props {
  filter: DigiUserFilters;
  userRole?: string;
  onChange: (filter: DigiUserFilters) => void;
}

const DigiUSerListFilters: React.FC<Props> = ({ filter, userRole, onChange }) => {  

  return (
    
    <div className="filter-grid">
        <Row gutter={16}>
        <Col><input type="text" className="search-bar" placeholder="Search by User Name..." value={filter.userName} onChange={(e) => onChange({ userName: e.target.value })} /></Col>
        <Col><input type="text" className="search-bar" placeholder="Search by First Name..." value={filter.firstName} onChange={(e) => onChange({ firstName: e.target.value })} /></Col>
        <Col><input type="text" className="search-bar" placeholder="Search by Mobile Number..." value={filter.mobileNumber} onChange={(e) => onChange({ mobileNumber: e.target.value })} /></Col>
        <Col><input type="text" className="search-bar" placeholder="Search by Ancestor..." value={filter.parentId} onChange={(e) => onChange({ parentId: e.target.value })} /></Col>
        <Col><input type="text" className="search-bar" placeholder="Search by Role..." value={filter.role} onChange={(e) => onChange({ role: e.target.value })} /></Col>
      </Row>
    </div>
    
  );
};

export default DigiUSerListFilters;
